module.exports = __webpack_public_path__ + "static/media/edit-recurring-fr.c772ca5d.png";